const broadcast_list_show = (state = [], action) => {
  switch (action.type) {
    case "broadcast_list_store":
      return action.payload;
    default:
      return state;
  }
};

export default broadcast_list_show;
